export const TWOU_CREATIVE_APP = 'react-page';
export const RV_CREATIVE_APP = 'creative-page';
